
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir//images/landing/",
    };
  },
  methods: {
    banner(image: string) {
      if (image !== "") {
        return this.url + image;
      } else {
        return this.defaultImage;
      }
    },
    // submitMainBanner() {
    //   store.dispatch("admin/uploadAboutUsMainBanner", {
    //     image: this.chosenFile,
    //   });
    // },
    submitContent() {
      const data = {
        title: this.title,
        text: this.description,
        image: this.chosenFile,
      };
      store.dispatch("admin/submitMoreBoxContent", data);
    },
    uploadMainBannerImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch(
            "admin/updateMoreBoxContentImage",
            event?.target?.result
          );
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },
    cancel(): void {
      router.push({ name: "admin-all-products" });
    },

    deleteBox(id: string): void {
      store.dispatch("admin/deleteMoreBox", id);
    },
  },
  computed: {
    boxes() {
      return store.state.admin.landing.moreBoxes;
    },
    //   languages(): any[] {
    //     let items: any[] = [
    //       {
    //         title: "انگلیسی",
    //         value: "En",
    //       },
    //       {
    //         title: "فارسی",
    //         value: "Fa",
    //       },
    //       {
    //         title: "عربی",
    //         value: "Ar",
    //       },
    //     ];
    //     return items;
    //   },

    title: {
      get(): string {
        return store.state.admin.landing.moreBoxContent.title;
      },
      set(value: string): void {
        store.dispatch("admin/updateMoreBoxContentTitle", value);
      },
    },

    titleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    //   language: {
    //     get(): string {
    //       return store.state.admin.landing.aboutUs.language;
    //     },
    //     set(value: any): void {
    //       store.dispatch("admin/updateAboutUsLanguage", value);
    //     },
    //   },
    //   languageError(): string[] {
    //     const errors: string[] = [];
    //     if (!this.$v.language?.$dirty) {
    //       return errors;
    //     }
    //     !this.$v.language.required && errors.push("تکمیل این فیلد الزامی است");
    //     return errors;
    //   },
    description: {
      get(): string {
        return store.state.admin.landing.moreBoxContent.description;
      },
      set(value: string): void {
        store.dispatch("admin/updateMoreBoxContentDescription", value);
      },
    },
    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },

  validations: {
    title: {
      required,
    },
    // language: {
    //   required,
    // },
    description: {
      required,
    },
  },

  mounted() {
    store.dispatch("admin/getLandingMoreBoxes");
  },
});
